














import jwtDecode from 'jwt-decode';
import APIService from '@/api';
import AdminService from '@/api/AdminService';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ImpersonateBar extends Vue {
  adminService = new AdminService();

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get adminCredentials() {
    const AdminCredentials = this.adminService.getCredentials(true);
    return AdminCredentials && jwtDecode(AdminCredentials).extraInfo;
  }

  disableImpersonate() {
    this.adminService.disableImpersonate().then(res => {
      if (res && res.data) {
        const { access_token } = res.data;
        APIService.resetCredentials(() => {
          this.adminService.setCredentials(access_token, true);
          window.location.assign('/admin/businesses');
        });
      }
    });
  }
}
